namespace TabAurous.Common {
    export interface APIImportResponse extends Serenity.ServiceResponse {
        Products?: Purchase.PurchaseItemsRow[];
        Issues?: Issue[];
        VouchersCompleted?: string[];
        VoucherswithIssues?: VoucherWithIssues[];
    }
}
